<template>
    <div class="planned-objective__progress">
        <div class="progress-bar">
            <div class="progress-bar__bar"
                 :class="{'progress-bar__bar--completed': objective.completed_activities_count === objective.activities_count }"
                 :style="{width: 'calc('+objective.completed_activities_count+'/'+objective.activities_count+' * 100%)'}"></div>
        </div>
        <div v-if="objective.completed_activities_count !== objective.activities_count || !onObjective" class="planned-objective__progress-in-number"><span
                class="color-green">{{objective.completed_activities_count}}</span> /
            {{objective.activities_count}} <slot></slot>
        </div>

        <div v-if="objective.completed_activities_count === objective.activities_count && onObjective" class="planned-objective__progress-in-number">
            <span class="color-green" v-translate>Objective completed</span>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'objective-progress-bar',
        props: {
            objective: {},
            onObjective: {type: Boolean, default: false}
        }
    }
</script>